var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRechnungen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7.30005H10.8",
    stroke: "#CD9D41",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7998 7.30005H4.1498",
    stroke: "#CD9D41",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7998 4.84985H4.1498",
    stroke: "#CD9D41",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7998 9.75H4.1498",
    stroke: "#CD9D41",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 9.75H10.1M6.25 9.75H8.35",
    stroke: "#CD9D41",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 4.84985H8.7M6.25 4.84985H6.95",
    stroke: "#CD9D41",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 4.5V4.05904C13.6 3.22393 13.6 2.80638 13.4894 2.46962C13.2797 1.83103 12.7928 1.32967 12.1724 1.11383C11.8453 1 11.4397 1 10.6285 1H3.97151C3.1603 1 2.7547 1 2.42757 1.11383C1.80725 1.32967 1.32024 1.83103 1.11056 2.46962C1 2.80638 1 3.22393 1 4.05904V10.1M13.6 7.3V13.8619C13.6 14.4627 12.9105 14.7815 12.4743 14.3823C12.2181 14.1478 11.8319 14.1478 11.5757 14.3823L11.2375 14.6918C10.7884 15.1028 10.1116 15.1028 9.6625 14.6918C9.21338 14.2808 8.53662 14.2808 8.0875 14.6918C7.63838 15.1028 6.96162 15.1028 6.5125 14.6918C6.06338 14.2808 5.38661 14.2808 4.9375 14.6918C4.48839 15.1028 3.81161 15.1028 3.3625 14.6918L3.02433 14.3823C2.76808 14.1478 2.38192 14.1478 2.12567 14.3823C1.6895 14.7815 1 14.4627 1 13.8619V12.9",
    stroke: "#CD9D41",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRechnungen);
export default __webpack_public_path__ + "static/media/Rechnungen.8ba67ae205c3ee03ed112bd9dcba173b.svg";
export { ForwardRef as ReactComponent };